import echarts from "echarts"
export default {
  data() {
    return {
      summary:[
        {key: '粪污处理量', value: 549, unit: 'm³'},
        {key: '餐厨处理量', value: 9563, unit: 't'},
        {key: '提油售出量', value: 512349, unit: 't'},
        {key: '堆肥售出量', value: 2123.34, unit: 't'},
        {key: '碳排放量', value: 512349, unit: 'tCO₂e'},
        {key: '碳减排量', value: 2123.34, unit: 'tCO₂e'},
      ],
      tasks:{
        total:234,
        data:[
          {key: '待抽', num: 121, percent: 58, color: '#5A3FFF'},
          {key: '待修', num: 47, percent: 5, color: '#268AFF'},
          {key: '超时', num: 48, percent: 36, color: '#3DFFDC'},
        ]
      },
      taskSum:{
        color: ['#009CF4', '#00F0FF'],
        grid:{
          top: 30
        },
        tooltip: {
            show:false
        },
        legend: {
            data: ['任务数', '金额数'],
            textStyle:{
              color: '#FFFFFF'
            }
        },
        xAxis: [
            {
                type: 'category',
                axisTick: {show: false},
                axisLabel:{
                  color:'#0E91EE',
                  interval: 0,
                  rotate: 45
                },
                data: ['泃阳镇', '燕郊镇', '高楼镇', '齐心庄镇', '李旗庄镇', '黄土庄镇', '段甲岭镇', '杨庄镇', '皇庄镇', '新集镇', '鼎盛东大街', '泃阳西大街']
            }
        ],
        yAxis: [
            {
                type: 'value',
                axisLabel:{color:'#0E91EE'},
                splitNumber: 4,
                minInterval: 25
            }
        ],
        series: [
            {
                name: '任务数',
                type: 'bar',
                barGap: 0,
                itemStyle: {
                  borderRadius:[5,5,0,0]
                },
                barWidth: '25%',
                barGap: '40%',
                label: {
                  show:false
                },
                data: [75, 48, 95, 30, 28, 48, 70, 48, 95, 30, 28, 40]
            },
            {
                name: '金额数',
                type: 'bar',
                itemStyle: {
                  borderRadius:[5,5,0,0]
                },
                barWidth: '25%',
                barGap: '40%',
                label: {
                  show:false
                },
                data: [72, 45, 90, 26, 24, 45, 66, 44, 90, 26, 24, 36]
            }
        ],
      },
      warning: [
        {type: '超速报警', name: '冀RAL123', time: '2020-07-02 22:32'},
        {type: '乱倒报警', name: '冀RAR456', time: '2020-07-02 22:32'},
        {type: '液位超标', name: '处理站1', time: '2020-07-02 22:32'},
        {type: '超速报警', name: '鲁BA4548', time: '2020-07-02 22:32'},
        {type: '超速报警', name: '冀RA4561', time: '2020-07-02 22:32'},
      ],
      coordination:[
        {key: '村庄数', value: 2000, unit: '个'},
        {key: '厕改数', value: 3656, unit: '个'},
        {key: '本月粪污', value: 78934, unit: 'm³'},
        {key: '本月粪污残渣', value: 789.4, unit: 't'},
        {key: '本月餐厨入场', value: 2000, unit: 't'},
        {key: '本月餐厨残渣', value: 2123.3, unit: 't'},
        {key: '本月堆肥售出', value: 78954, unit: 't'},
      ],
      lineChart:[
        {
          animation: false,
          legend: {
            show: false
          },
          grid:{
            top: 30
          },
          xAxis: {
            type: 'category',
            axisTick: {show: false},
            axisLabel:{
              color:'#FFFFFF',
              interval: 0
            },
            data: ['03/06', '03/07', '03/08', '03/09', '03/10', '03/11']
          },
          yAxis: {
            type: 'value',
            name:'吨',
            axisLabel:{color:'#0E91EE'},
            nameLocation: 'end',
            interval: 200,
            minInterval: 200
          },
          series: [
            {
                type: 'line',
                smooth: true,
                symbol: 'none',
                itemStyle: {
                    color: '#FFC300'
                },
                areaStyle: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                        offset: 0,
                        color: 'rgba(255, 169, 40, 0.81)'
                    }, {
                        offset: 1,
                        color: 'rgba(255, 169, 40, 0)'
                    }])
                },
                data: [610, 200, 300, 600, 350, 100]
            },
          ]
        },{
          animation: false,
          legend: {
            show: false
          },
          grid:{
            top: 30
          },
          xAxis: {
            type: 'category',
            axisTick: {show: false},
            axisLabel:{
              color:'#FFFFFF',
              interval: 0
            },
            data: ['03/06', '03/07', '03/08', '03/09', '03/10', '03/11']
          },
          yAxis: {
            type: 'value',
            name:'吨',
            axisLabel:{color:'#0E91EE'},
            nameLocation: 'end',
            interval: 200,
            minInterval: 200
          },
          series: [
            {
                type: 'line',
                smooth: true,
                symbol: 'none',
                itemStyle: {
                    color: '#10AEFF'
                },
                areaStyle: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                        offset: 0,
                        color: 'rgba(40, 126, 255, 0.81)'
                    }, {
                        offset: 1,
                        color: 'rgba(22, 143, 255, 0)'
                    }])
                },
                data: [610, 200, 300, 600, 350, 100]
            },
          ]
        },{
          animation: false,
          legend: {
            show: false
          },
          grid:{
            top: 30
          },
          xAxis: {
            type: 'category',
            axisTick: {show: false},
            axisLabel:{
              color:'#FFFFFF',
              interval: 0
            },
            data: ['03/06', '03/07', '03/08', '03/09', '03/10', '03/11']
          },
          yAxis: {
            type: 'value',
            name:'吨',
            axisLabel:{color:'#0E91EE'},
            nameLocation: 'end',
            interval: 200,
            minInterval: 200
          },
          series: [
            {
                type: 'line',
                smooth: true,
                symbol: 'none',
                itemStyle: {
                    color: '#31FBFB'
                },
                areaStyle: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                        offset: 0,
                        color: 'rgba(26, 238, 251, 1)'
                    }, {
                        offset: 1,
                        color: 'rgba(19, 227, 254, 0)'
                    }])
                },
                data: [610, 200, 300, 600, 350, 100]
            },
          ]
        },
      ]
    }
  }
} 


// WEBPACK FOOTER //
// ./src/components/ProductDetails/mod_screen_display_show/assets/data.js